import { render, staticRenderFns } from "./foreCastReport.vue?vue&type=template&id=38155e41"
import script from "./foreCastReport.vue?vue&type=script&lang=js"
export * from "./foreCastReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports